import React, { useMemo } from "react";
import _ from "lodash";
import { useLocation } from "react-router-dom";
import { connect, ConnectedProps } from "react-redux";

import { ListItem, GridItem } from "./Components";
import {
  TemplateActions,
  TemplateCategory,
  TemplateGroups,
  TemplateViewType,
} from "components/EditorHome/Constants";
import { $Empty, $Row } from "us.common/components";
import { getTemplatesByGroupAndCategory } from "functions";
import { RootState } from "us.helper/types";
import { ITemplateList } from "./interface";
import { getUrlParams } from "components/EditorHome/Functions";
import "./TemplateList.scss";
import { ITemplate } from "interfaces";
import {
  getTemplateCategoryName,
  getTemplateGroupName,
} from "functions/EditorHome";

/**
 * @description - Template list component.
 * @link Design Document -
 * @author Ishan Udyoga <ishanud@unicorn-solutions.com>
 * @since 11/09/2022
 */
const TemplateList: React.FC<ITemplateList & PropsFromRedux> = ({
  templates,
  templateView,
  handleTemplateAction,
}) => {
  const { search } = useLocation();

  const { categoryId, groupId } = getUrlParams(search);

  const groupName = useMemo(() => {
    return getTemplateGroupName(templates.groups, groupId);
  }, [groupId, templates.groups]);

  const templatesList = useMemo(
    () =>
      getTemplatesByGroupAndCategory(templates.groups, groupName, categoryId),
    [templates.groups, groupName, categoryId]
  );

  return (
    <div className="content-list-template" id="templateList">
      {templateView == TemplateViewType.GRID && (
        <$Row gutter={[12, 12]}>
          {templatesList.map((template: ITemplate) => {
            return (
              <GridItem
                key={template.templateName + template.templateId}
                template={template}
                onCallAction={(actionType: TemplateActions) =>
                  handleTemplateAction(actionType, template)
                }
              />
            );
          })}
        </$Row>
      )}
      {templateView == TemplateViewType.LIST && (
        <>
          {templatesList.map((template: ITemplate, index: number) => {
            return (
              <ListItem
                key={template.templateName + template.templateId}
                template={template}
                onCallAction={(actionType: TemplateActions) =>
                  handleTemplateAction(actionType, template)
                }
              />
            );
          })}
          {templatesList?.length == 0 && !templates.loading && (
            <$Empty image={$Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const { templatesHistory } = state;
  const { templates } = templatesHistory;

  return {
    templates,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(TemplateList);
